var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 39.9,
    height: 71.4,
    viewBox: "0 0 39.9 71.4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.25,
    d: "M31.5 4.2L12.6 4.2C7.96081 4.2 4.2 7.96081 4.2 12.6L4.2 63C4.2 67.6392 7.96081 71.4 12.6 71.4L31.5 71.4C36.1392 71.4 39.9 67.6392 39.9 63L39.9 12.6C39.9 7.96081 36.1392 4.2 31.5 4.2Z",
    fill: "#047857"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.3 2.88393e-07H8.4C3.76081 2.88393e-07 0 3.76081 0 8.4V58.8C0 63.4392 3.76081 67.2 8.4 67.2H27.3C31.9392 67.2 35.7 63.4392 35.7 58.8V8.4C35.7 3.76081 31.9392 2.88393e-07 27.3 2.88393e-07Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.25 6.3L9.45 6.3C6.55051 6.3 4.2 8.65051 4.2 11.55L4.2 53.55C4.2 56.4495 6.55051 58.8 9.45 58.8L26.25 58.8C29.1495 58.8 31.5 56.4495 31.5 53.55L31.5 11.55C31.5 8.6505 29.1495 6.3 26.25 6.3Z",
    fill: "url(#paint1_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    d: "M22.995 2.73L12.705 2.73C12.0671 2.73 11.55 3.24711 11.55 3.885C11.55 4.52289 12.0671 5.04 12.705 5.04L22.995 5.04C23.6329 5.04 24.15 4.52289 24.15 3.885C24.15 3.24711 23.6329 2.73 22.995 2.73Z",
    fill: "#065F46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.8,
    d: "M6.3 14.7L16.8 8.4",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 0,
    y1: 2.88393e-7,
    x2: 55.6844,
    y2: 29.5823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7F3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 4.2,
    y1: 6.3,
    x2: 47.1786,
    y2: 28.6489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1FAE5",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllMobile);
export default __webpack_public_path__ + "static/media/ill-mobile.71c08e00cf55d1946cef96902e181089.svg";
export { ForwardRef as ReactComponent };